export const getAnswerForCustomQuestion = (answer) =>
  answer?.answerText || answer?.answerOption?.answer;
